import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { A, Styles, ButtonLink } from '@contently/toolkit';

const StyledContent = styled.div`
  min-width: 320px;
  max-width: 568px;
  text-align: center;
  margin: 175px auto 0px;
  color: ${Styles.colors.white};
`;

const StyledH1 = styled.h1`
  font-size: 36px;
`;

const StyledH2 = styled.h2`
  font-size: 24px;
  font-weight: 400;
  margin: 45px 0px;
  color: rgb(252, 109, 79);
`;

const StyledButtonLink = styled(ButtonLink)`
  margin-bottom: 15px;
  &:hover {
    text-decoration: none;
  }
`;

const ErrorContent = ({ primaryMessage, secondaryMessage }) => {
  return (
    <StyledContent>
      <StyledH1>{primaryMessage}</StyledH1>
      <StyledH2>{secondaryMessage}</StyledH2>
      <p>
        <StyledButtonLink size="medium" variant="primary" href="/home" title="Back to Contently">
          Back to Contently
        </StyledButtonLink>
        <br />
        Keeps happening?
        {'  '}
        <A href="mailto:support@contently.com">Contact Support</A>
      </p>
    </StyledContent>
  );
};

ErrorContent.propTypes = {
  primaryMessage: PropTypes.string.isRequired,
  secondaryMessage: PropTypes.string.isRequired
};

export default ErrorContent;



// WEBPACK FOOTER //
// ./app/javascript/client/components/ErrorContent.jsx